// eslint-disable-next-line no-restricted-imports
import dayjs, { type Dayjs } from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import duration from 'dayjs/plugin/duration';
import format from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(calendar);
dayjs.extend(format);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);

dayjs.locale('en', {
  ...dayjs.Ls.en,
  relativeTime: {
    ...dayjs.Ls.en.relativeTime,
    mm: '%d min',
  },
});

export const DATE_FORMAT = 'll'; // MMM D, YYYY
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export { dayjs, type Dayjs };

export default dayjs;
